exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "user-details{display:block;display:flex;justify-content:center}user-details .md-body{margin-bottom:0}md-menu-content md-menu-item>.md-button{display:flex}md-menu-content md-menu-item>.md-button small{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/user/userDetails/userDetails.scss
// module id = 542
// module chunks = 0